var _ellipse, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWavingKiwi = function SvgWavingKiwi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14973",
    "data-name": "Group 14973",
    width: 126.568,
    height: 105.457,
    viewBox: "0 0 126.568 105.457",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_855",
    "data-name": "Ellipse 855",
    cx: 52.729,
    cy: 52.728,
    rx: 52.729,
    ry: 52.728,
    transform: "translate(21.111 0)",
    fill: "#bcf1ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_25",
    "data-name": "Intersection 25",
    d: "M0,62.589c1.064-6.975,4.589-14.273,15.516-19.762,21.655-10.877,3.658-24.034,3.658-24.034H1.855c7.7-4.7,9.772-25.306,29.881-16.725C47.453,8.774,62.6,36.751,60.07,56.3A53.087,53.087,0,0,1,25.493,69.16,52.619,52.619,0,0,1,0,62.589Z",
    transform: "translate(48.232 36.297)",
    fill: "#b2926e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M47.2,4.015c-5.365.568-14.75,6.184-29.159,18.266S-.906,43.187.145,44.907,10.35,38.128,29.25,29.189s29.464-8.7,37.977-13.731S76.4,2.218,72.651.329,66.3,5.338,60.916,4.4A49.223,49.223,0,0,0,47.2,4.015Z",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 18.356, 16.852)",
    fill: "#fec95f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14166",
    "data-name": "Group 14166",
    transform: "translate(43.897 16.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse",
    d: "M8.727,0c4.85.025,8.807,4.982,8.838,11.073S13.688,22.079,8.838,22.054.031,17.072,0,10.982,3.876-.025,8.727,0Z",
    transform: "translate(3.553 3.56) rotate(9.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M10.754,2.589C10.79,2.237,7.624-.016,5.585,0,2.066.009.036,4.615,0,4.966S2.907,1.828,5.444,1.406,10.719,2.94,10.754,2.589Z",
    transform: "translate(0.497 2.052) rotate(-11)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M11.885,1.756c1.709,2.462.617,6.621-2.444,9.286s-6.926,2.823-8.634.351S.191,4.773,3.251,2.107,10.177-.716,11.885,1.756Z",
    transform: "translate(0.901 13.905) rotate(-34)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M7.428,1.094c1.065,1.54.379,4.139-1.528,5.8S1.567,8.663.5,7.113s-.379-4.139,1.529-5.8S6.363-.446,7.428,1.094Z",
    transform: "translate(4.114 14.418) rotate(-34)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    d: "M2.132,2.217C2.44,1.2,2.243.177,1.7.021S.454.6.146,1.656.035,3.7.582,3.852,1.823,3.277,2.132,2.217Z",
    transform: "matrix(-0.875, -0.485, 0.485, -0.875, 8.665, 13.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse-2",
    "data-name": "ellipse",
    d: "M10.014,0c5.575.036,10.13,5.733,10.174,12.725S15.749,25.356,10.175,25.32.045,19.586,0,12.595,4.439-.036,10.014,0Z",
    transform: "matrix(0.965, 0.263, -0.263, 0.965, 19.47, 3.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    d: "M13.215,1.965c1.9,2.752.692,7.4-2.71,10.373S2.8,15.486.9,12.723.208,5.324,3.61,2.349,11.312-.8,13.215,1.965Z",
    transform: "translate(16.367 14.817) rotate(-28)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    d: "M8.259,1.225C9.446,2.946,8.685,5.85,6.565,7.7s-4.818,1.971-6,.239-.426-4.625,1.7-6.479S7.073-.5,8.259,1.225Z",
    transform: "translate(19.866 15.767) rotate(-28)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    d: "M2.38,2.469C2.723,1.335,2.5.2,1.89.023S.5.662.162,1.841.04,4.112.651,4.287,2.036,3.648,2.38,2.469Z",
    transform: "translate(25.181 15.517) rotate(-147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    "data-name": "path",
    d: "M5.207,10.794c.292-.222,2.188-4.93.487-7.868A6.025,6.025,0,0,0,.019.071C-.273.293,2.894.917,4.527,3.816S4.915,11.016,5.207,10.794Z",
    transform: "translate(31.692 3.681) rotate(-11)",
    fill: "#b2926e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9293",
    "data-name": "Path 9293",
    d: "M2.6,11.223a15.484,15.484,0,0,0-2.457,10.6L14.982,5.065,13.162,0S6.106,5.729,2.6,11.223Z",
    transform: "translate(81.763 54.074) rotate(-16)",
    fill: "#a78866"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9291",
    "data-name": "Path 9291",
    d: "M.66,31.258S-2.046,26.2,3.5,18.437A112.457,112.457,0,0,1,12.459,7.61c.84-.9,2.112-2.2,3.366-3.4C18.747,1.413,21.669-.64,22.85.183c2.617,1.828,1.072,19.665-3.42,33.5",
    transform: "translate(86.582 45.218) rotate(-2)",
    fill: "#b2926e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9290",
    "data-name": "Path 9290",
    d: "M.659,31.259S-2.046,26.206,3.5,18.438A112.468,112.468,0,0,1,12.459,7.611c.84-.9,2.112-2.2,3.366-3.4C18.748,1.413,21.669-.64,22.85.183c2.117,1.479,1.931,12.712-.618,24.371-.575,2.63-1.3,5.378-2.16,8.019",
    transform: "translate(97.418 45.148) rotate(24)",
    fill: "#b2926e",
    opacity: 0.302
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9292",
    "data-name": "Path 9292",
    d: "M.647,30.615s-2.653-4.954,2.787-12.57A110.252,110.252,0,0,1,12.215,7.43c.824-.885,1.636-1.572,2.866-2.746C17.945,1.944,21.244-.658,22.4.149c2.566,1.793,1.682,18.2-2.722,31.756",
    transform: "translate(78.759 49.122) rotate(-13)",
    fill: "#b2926e",
    opacity: 0.302
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9294",
    "data-name": "Path 9294",
    d: "M.011,2.255c-.217-.819,2.967.554,5.607.013S10.856-.72,11.612.208,10,4.826,6.483,5.548.227,3.077.011,2.255Z",
    transform: "translate(66.663 49.448) rotate(7)",
    fill: "#e5b452"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWavingKiwi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wavingKiwi.4c645292.svg";
export { ForwardRef as ReactComponent };